/** 套餐展示配置（实际成交价以 order/create 返回为准） */
export const PLANS = [
  {
    years: 1,
    label: '一 年',
    price: '9888',
    originPrice: '12000',
    daily: '27.09',
  },
  // {
  //   years: 2,
  //   label: '两 年',
  //   price: '16888',
  //   originPrice: '16000',
  //   daily: '13.54',
  // },
  // {
  //   years: 3,
  //   label: '三 年',
  //   price: '13888',
  //   originPrice: '18000',
  //   daily: '12.68',
  // },
  // {
  //   years: 4,
  //   label: '四 年',
  //   price: '16888',
  //   originPrice: '24000',
  //   daily: '11.56',
  // },
];

export const DEFAULT_PLAN_YEARS = 1;

export const PAY_CHANNEL = 'alipay';

/** true=本地 simulate_pay，false=正式 pay_params 扫码 */
export const USE_SIMULATE_PAY = false;

/** 支付宝 qr_pay_mode：4=可定义宽度的嵌入式二维码，需配合 QR_WIDTH */
export const QR_MODE = '4';
export const QR_WIDTH = '260';

/** 支付结果轮询间隔（毫秒） */
export const POLL_INTERVAL_MS = 1000;

/** 轮询超时：5 分钟未支付则关闭支付弹窗 */
export const POLL_TIMEOUT_MS = 5 * 60 * 1000;

/** 支付宝扫码支付成功后同步跳转路由（iframe 内展示） */
export const PAY_SUCCESS_ROUTE = '/user/purchase/pay-success';

export const BENEFITS = {
  title: '权益介绍：杰宜斯易小助多账户交易端软件',
  items: [
    '多账号下单工具满足机构多个交易账号进行下单场景',
    '支持跨期货公司、多个交易后台同时登录，可配置多账号同步交易',
    '支持多账号条件单 / 止盈止损单，操作简便',
  ],
};



// WEBPACK FOOTER //
// ./src/view/user/purchaseService/config.js